export default __webpack_public_path__ + "static/media/unlock.d1f96246.svg";